export const timeList = [
  {
    id: '1',
    time: '12:00 am',
    hours: 0,
    minutes: 0
  },
  {
    id: '2',
    time: '12:15 am',
    hours: 0,
    minutes: 15
  },
  {
    id: '3',
    time: '12:30 am',
    hours: 0,
    minutes: 30
  },
  {
    id: '4',
    time: '12:45 am',
    hours: 0,
    minutes: 45
  },
  {
    id: '5',
    time: '01:00 am',
    hours: 1,
    minutes: 0
  },
  {
    id: '6',
    time: '01:15 am',
    hours: 1,
    minutes: 15
  },
  {
    id: '7',
    time: '01:30 am',
    hours: 1,
    minutes: 30
  },
  {
    id: '8',
    time: '01:45 am',
    hours: 1,
    minutes: 45
  },
  {
    id: '9',
    time: '02:00 am',
    hours: 2,
    minutes: 0
  },
  {
    id: '10',
    time: '02:15 am',
    hours: 2,
    minutes: 15
  },
  {
    id: '11',
    time: '02:30 am',
    hours: 2,
    minutes: 30
  },
  {
    id: '12',
    time: '02:45 am',
    hours: 2,
    minutes: 45
  },
  {
    id: '13',
    time: '03:00 am',
    hours: 3,
    minutes: 0
  },
  {
    id: '14',
    time: '03:15 am',
    hours: 3,
    minutes: 15
  },
  {
    id: '15',
    time: '03:30 am',
    hours: 3,
    minutes: 30
  },
  {
    id: '16',
    time: '03:45 am',
    hours: 3,
    minutes: 45
  },
  {
    id: '17',
    time: '04:00 am',
    hours: 4,
    minutes: 0
  },
  {
    id: '18',
    time: '04:15 am',
    hours: 4,
    minutes: 15
  },
  {
    id: '19',
    time: '04:30 am',
    hours: 4,
    minutes: 30
  },
  {
    id: '20',
    time: '04:45 am',
    hours: 4,
    minutes: 45
  },
  {
    id: '21',
    time: '05:00 am',
    hours: 5,
    minutes: 0
  },
  {
    id: '22',
    time: '05:15 am',
    hours: 5,
    minutes: 15
  },
  {
    id: '23',
    time: '05:30 am',
    hours: 5,
    minutes: 30
  },
  {
    id: '24',
    time: '05:45 am',
    hours: 5,
    minutes: 45
  },
  {
    id: '25',
    time: '06:00 am',
    hours: 6,
    minutes: 0
  },
  {
    id: '26',
    time: '06:15 am',
    hours: 6,
    minutes: 15
  },
  {
    id: '27',
    time: '06:30 am',
    hours: 6,
    minutes: 30
  },
  {
    id: '28',
    time: '06:45 am',
    hours: 6,
    minutes: 45
  },
  {
    id: '29',
    time: '07:00 am',
    hours: 7,
    minutes: 0
  },
  {
    id: '30',
    time: '07:15 am',
    hours: 7,
    minutes: 15
  },
  {
    id: '31',
    time: '07:30 am',
    hours: 7,
    minutes: 30
  },
  {
    id: '32',
    time: '07:45 am',
    hours: 7,
    minutes: 45
  },
  {
    id: '33',
    time: '08:00 am',
    hours: 8,
    minutes: 0
  },
  {
    id: '34',
    time: '08:15 am',
    hours: 8,
    minutes: 15
  },
  {
    id: '35',
    time: '08:30 am',
    hours: 8,
    minutes: 30
  },
  {
    id: '36',
    time: '08:45 am',
    hours: 8,
    minutes: 45
  },
  {
    id: '37',
    time: '09:00 am',
    hours: 9,
    minutes: 0
  },
  {
    id: '38',
    time: '09:15 am',
    hours: 9,
    minutes: 15
  },
  {
    id: '39',
    time: '09:30 am',
    hours: 9,
    minutes: 30
  },
  {
    id: '40',
    time: '09:45 am',
    hours: 9,
    minutes: 45
  },
  {
    id: '41',
    time: '10:00 am',
    hours: 10,
    minutes: 0
  },
  {
    id: '42',
    time: '10:15 am',
    hours: 10,
    minutes: 15
  },
  {
    id: '43',
    time: '10:30 am',
    hours: 10,
    minutes: 30
  },
  {
    id: '44',
    time: '10:45 am',
    hours: 10,
    minutes: 45
  },
  {
    id: '45',
    time: '11:00 am',
    hours: 11,
    minutes: 0
  },
  {
    id: '46',
    time: '11:15 am',
    hours: 11,
    minutes: 15
  },
  {
    id: '47',
    time: '11:30 am',
    hours: 11,
    minutes: 30
  },
  {
    id: '48',
    time: '11:45 am',
    hours: 11,
    minutes: 45
  },
  {
    id: '49',
    time: '12:00 pm',
    hours: 12,
    minutes: 0
  },
  {
    id: '50',
    time: '12:15 pm',
    hours: 12,
    minutes: 15
  },
  {
    id: '51',
    time: '12:30 pm',
    hours: 12,
    minutes: 30
  },
  {
    id: '52',
    time: '12:45 pm',
    hours: 12,
    minutes: 45
  },
  {
    id: '53',
    time: '01:00 pm',
    hours: 13,
    minutes: 0
  },
  {
    id: '54',
    time: '01:15 pm',
    hours: 13,
    minutes: 15
  },
  {
    id: '55',
    time: '01:30 pm',
    hours: 13,
    minutes: 30
  },
  {
    id: '56',
    time: '01:45 pm',
    hours: 13,
    minutes: 45
  },
  {
    id: '57',
    time: '02:00 pm',
    hours: 14,
    minutes: 0
  },
  {
    id: '58',
    time: '02:15 pm',
    hours: 14,
    minutes: 15
  },
  {
    id: '59',
    time: '02:30 pm',
    hours: 14,
    minutes: 30
  },
  {
    id: '60',
    time: '02:45 pm',
    hours: 14,
    minutes: 45
  },
  {
    id: '61',
    time: '03:00 pm',
    hours: 15,
    minutes: 0
  },
  {
    id: '62',
    time: '03:15 pm',
    hours: 15,
    minutes: 15
  },
  {
    id: '63',
    time: '03:30 pm',
    hours: 15,
    minutes: 30
  },
  {
    id: '64',
    time: '03:45 pm',
    hours: 15,
    minutes: 45
  },
  {
    id: '65',
    time: '04:00 pm',
    hours: 16,
    minutes: 0
  },
  {
    id: '66',
    time: '04:15 pm',
    hours: 16,
    minutes: 15
  },
  {
    id: '67',
    time: '04:30 pm',
    hours: 16,
    minutes: 30
  },
  {
    id: '68',
    time: '04:45 pm',
    hours: 16,
    minutes: 45
  },
  {
    id: '69',
    time: '05:00 pm',
    hours: 17,
    minutes: 0
  },
  {
    id: '70',
    time: '05:15 pm',
    hours: 17,
    minutes: 15
  },
  {
    id: '71',
    time: '05:30 pm',
    hours: 17,
    minutes: 30
  },
  {
    id: '72',
    time: '05:45 pm',
    hours: 17,
    minutes: 45
  },
  {
    id: '73',
    time: '06:00 pm',
    hours: 18,
    minutes: 0
  },
  {
    id: '74',
    time: '06:15 pm',
    hours: 18,
    minutes: 15
  },
  {
    id: '75',
    time: '06:30 pm',
    hours: 18,
    minutes: 30
  },
  {
    id: '76',
    time: '06:45 pm',
    hours: 18,
    minutes: 45
  },
  {
    id: '77',
    time: '07:00 pm',
    hours: 19,
    minutes: 0
  },
  {
    id: '78',
    time: '07:15 pm',
    hours: 19,
    minutes: 15
  },
  {
    id: '79',
    time: '07:30 pm',
    hours: 19,
    minutes: 30
  },
  {
    id: '80',
    time: '07:45 pm',
    hours: 19,
    minutes: 45
  },
  {
    id: '81',
    time: '08:00 pm',
    hours: 20,
    minutes: 0
  },
  {
    id: '82',
    time: '08:15 pm',
    hours: 20,
    minutes: 15
  },
  {
    id: '83',
    time: '08:30 pm',
    hours: 20,
    minutes: 30
  },
  {
    id: '84',
    time: '08:45 pm',
    hours: 20,
    minutes: 45
  },
  {
    id: '85',
    time: '09:00 pm',
    hours: 21,
    minutes: 0
  },
  {
    id: '86',
    time: '09:15 pm',
    hours: 21,
    minutes: 15
  },
  {
    id: '87',
    time: '09:30 pm',
    hours: 21,
    minutes: 30
  },
  {
    id: '88',
    time: '09:45 pm',
    hours: 21,
    minutes: 45
  },
  {
    id: '89',
    time: '10:00 pm',
    hours: 22,
    minutes: 0
  },
  {
    id: '90',
    time: '10:15 pm',
    hours: 22,
    minutes: 15
  },
  {
    id: '91',
    time: '10:30 pm',
    hours: 22,
    minutes: 30
  },
  {
    id: '92',
    time: '10:45 pm',
    hours: 22,
    minutes: 45
  },
  {
    id: '93',
    time: '11:00 pm',
    hours: 23,
    minutes: 0
  },
  {
    id: '94',
    time: '11:15 pm',
    hours: 23,
    minutes: 15
  },
  {
    id: '95',
    time: '11:30 pm',
    hours: 23,
    minutes: 30
  },
  {
    id: '96',
    time: '11:45 pm',
    hours: 23,
    minutes: 45
  }
];
